export default __webpack_public_path__ + "static/media/rvtlogorgb.035aba04.png";